import axios from "axios";
import authFirebase from "../../authFirebase";
const { ENDPOINT_API_CHATBOTS } = require("@/logic/globalEndpoints");

export default {
  //++++++++++++++++ Metodo POST para REGISTRAR UN NUEVO CHATBOT A CHATPRO +++++++++++++++++++++++++
  async register_chatbot(
    id_user,
    url_logo,
    chatbot_name,
    background_color_1,
    dark_1,
    background_color_2,
    dark_2,
    language,
    type,
    initial_prompt,
    status
  ) {
    const new_register_chatbot_model = {
      id_user: id_user,
      url_logo: url_logo,
      chatbot_name: chatbot_name,
      background_color_1: background_color_1,
      dark_1: dark_1,
      background_color_2: background_color_2,
      dark_2: dark_2,
      language: language,
      type: type,
      initial_prompt: initial_prompt,
      status: status,
    };

    const headers = {
      headers: {
        Authorization: "Bearer " + (await authFirebase.createTokenJWT()),
      },
    };

    const resp = await axios.post(
      ENDPOINT_API_CHATBOTS + "/api/b2c/data-chatbot",
      new_register_chatbot_model,
      headers
    );
    return resp;
  },

  //++++++++++++++++ Metodo GET para TRAER Sesion Conversion +++++++++++++++++++++++++
  async get_all_chatbots(id_user) {
    const params = {
      id_user: id_user,
    };

    const headers = {
      Authorization: "Bearer " + (await authFirebase.createTokenJWT()),
    };

    const resp = await axios.get(
      ENDPOINT_API_CHATBOTS + "/api/b2c/all-chatbots",
      { params, headers }
    );
    return resp;
  },

  //++++++++++++++++ Metodo GET para TRAER INFO DE UN SOLO CHATBOT +++++++++++++++++++++++++
  async get_data_chatbot(id_chatbot) {
    const params = {
      id_chatbot: id_chatbot,
    };

    const headers = {
      Authorization: "Bearer " + (await authFirebase.createTokenJWT()),
    };

    const resp = await axios.get(
      ENDPOINT_API_CHATBOTS + "/api/b2c/data-chatbot",
      { params, headers }
    );
    return resp;
  },

  //++++++++++++++++ Metodo UPDATE para ACTUALIZAR INFO DE UN SOLO CHATBOT +++++++++++++++++++++++++
  async update_data_chatbot(
    id_chatbot,
    url_logo,
    chatbot_name,
    background_color_1,
    dark_1,
    background_color_2,
    dark_2,
    language,
    type,
    initial_prompt,
    status,
    private_value,
    temperature,
    suggested_messages,
    welcome_message
  ) {
    const params = {
      id_chatbot: id_chatbot,
      url_logo: url_logo,
      chatbot_name: chatbot_name,
      background_color_1: background_color_1,
      dark_1: dark_1,
      background_color_2: background_color_2,
      dark_2: dark_2,
      language: language,
      type: type,
      initial_prompt: initial_prompt,
      status: status,
      private:private_value,
      temperature:temperature,
      suggested_messages:suggested_messages,
      welcome_message: welcome_message
    };

    const headers = {
      headers: {
        Authorization: "Bearer " + (await authFirebase.createTokenJWT()),
      },
    };

    const resp = await axios.put(
      ENDPOINT_API_CHATBOTS + "/api/b2c/data-chatbot",
      params,
      headers
    );
    return resp;
  },

  //++++++++++++++++ Metodo DELETE para eliminar UN SOLO CHATBOT +++++++++++++++++++++++++
  async delete_chatbot(id_user, id_chatbot) {
    const headers = {
      id_user: id_user,
      id_chatbot: id_chatbot,
      Authorization: "Bearer " + (await authFirebase.createTokenJWT()),
    };
    const resp = await axios.delete(
      ENDPOINT_API_CHATBOTS + "/api/b2c/data-chatbot",
      { headers }
    );
    return resp;
  },

  //++++++++++++++++ Metodo POST para REGISTRAR UN NUEVO CHATBOT A CHATPRO  V2.0 +++++++++++++++++++++++++
  async register_chatbot_MS(
    chatbot_name,
    language,
    model,
    background_color_1,
    dark_1,
    id_user,
    initial_prompt,
    temperature,
    private_aux,
    status,
    url_logo

  ) {
    const new_register_chatbot_model = {
      chatbot_name: chatbot_name,
      language: language,
      model: model,
      background_color_1: background_color_1,
      dark_1: dark_1,
      id_user: id_user,
      initial_prompt: initial_prompt,
      temperature: temperature,
      private: private_aux,
      status: status,
      url_logo: url_logo
    };

    const headers = {
      headers: {
        Authorization: "Bearer " + (await authFirebase.createTokenJWT()),
      },
    };

    const resp = await axios.post(
      ENDPOINT_API_CHATBOTS + "/api/b2c/ms-chatbot",
      new_register_chatbot_model,
      headers
    );
    return resp;
  },
};